import { ExceptionService } from '../services/exception.service';
import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { TogetherDIPStageContainer } from 'app/models/app.models';
import { DipStateService } from 'app/services/dip-state-service.service';
import { SubmissionRequestStatus, TogetherAuctionDIPEntityType } from 'app/models/enums';
import { NodeAPIEntityService } from 'app/services/node.entity.service';
import { TogetherAuctionDIPQuoteResult } from 'app/models/api.models';

@Component({
    selector: 'application-submission',
    templateUrl: './application-submission.component.html',
    styleUrls: ['./application-submission.component.scss'],
    standalone: false
})
export class ApplicationSubmissionComponent implements OnInit {
    /**
     * The current stage
     * 
     * @type {TogetherDIPStageContainer}
     * @memberof ApplicationSubmissionComponent
     */
    @Input() stage: TogetherDIPStageContainer;
    /**
     * Notify that stage is changing
     * 
     * @type {EventEmitter<string>}
     * @memberof ApplicationSubmissionComponent
     */
    @Output() stageChanging: EventEmitter<string> = new EventEmitter<string>();
    /**
     * The id of the case geing processed
     * 
     * @type {string}
     * @memberof ApplicationSubmissionComponent
     */
    @Input() caseId: string;
    /**
     * Get loading status from state
     * 
     * @readonly
     * @type {boolean}
     * @memberof ApplicationSubmissionComponent
     */
    get IsLoading(): boolean {
        return this.state.IsLoading;
    }

    constructor(private state: DipStateService, 
    private entity: NodeAPIEntityService,
    private exception: ExceptionService) { }

    ngOnInit() {
        // *TODO* Call get current state from API to workout where to redirect to 
        //  if not SubmissionRequestStatus.Initialised
        if (this.state.applicationSubmissionStatus === SubmissionRequestStatus.Initialised) {
            this.submitApplication(this.caseId);
        } else {
            this.stageChanging.emit('tad_stage_application_overview');
        }
    }

    private submitApplication(caseId) {
        this.state.IsLoading = true;
        this.state.applicationSubmissionStatus = SubmissionRequestStatus.Inprogress;
        this.entity.getAllEntities(TogetherAuctionDIPEntityType.SubmitQuote, caseId)
            .subscribe(
            (success) => {
                // this.quote_result = new TogetherAuctionDIPQuoteResult(success);
                this.state.applicationSubmissionStatus = SubmissionRequestStatus.Complete;
                this.state.IsLoading = false;
                this.stageChanging.emit('tad_stage_application_outcome');
            },
            (error) => {
                this.exception.haveReceivedError(error);
                this.state.IsLoading = false;
            },
        );

    }

}
